import React, { useState, useContext, useEffect, useRef } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { FacebookShareButton, InstapaperShareButton, TwitterShareButton } from 'react-share'
import { Button, Menu, MenuItem } from '@material-ui/core'
import { useParams } from 'react-router-dom'
import AlertContext from '@/product/context/alert/alertContext'

const Share = (props) => {
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const { id: paramsId } = useParams()
    const id = paramsId || props?.id || 0
    const [copyState, setCopyState] = useState({
        value: window.location.host + '/product-view/',
        copy: false,
    })

    return (
        <div className="share-menu">
            <Button onClick={props.handleClick}>
                {props.shareText ? (
                    'Share'
                ) : (
                    <span className="material-icons-outlined">ios_share</span>
                )}
            </Button>
            <Menu
                id="simple-menu"
                anchorEl={props.anchorEl}
                keepMounted
                open={Boolean(props.anchorEl)}
                onClose={props.handleClose}
                className="pgShare"
            >
                <MenuItem>
                    <CopyToClipboard
                        text={copyState.value + props.id || props.id}
                        onCopy={() => {
                            setCopyState({ ...copyState, copy: true })
                            setAlert('Copied Successfully', 'success')
                        }}
                    >
                        <Button className="copyClipboard">
                            <span className="material-icons">content_copy</span>
                            Copy Link
                        </Button>
                    </CopyToClipboard>
                </MenuItem>
                <MenuItem>
                    <FacebookShareButton
                        url={copyState.value + id || props.id || 0}
                        quote={props.title}
                    >
                        <span className="fab fa-facebook"></span>
                        Facebook
                    </FacebookShareButton>
                </MenuItem>
                <MenuItem>
                    <TwitterShareButton
                        url={copyState.value + id || props.id || 0}
                        quote={props.title}
                    >
                        <img src="/assets/images/twitter.png" alt="twitter" width="15" />
                        {/* <span className="fab fa-twitter"></span> */}X
                    </TwitterShareButton>
                    {/* <InstapaperShareButton
                        url={copyState.value + id || props.id || 0}
                        quote={props.title}
                    >
                        <span className="fab fa-instagram"></span>
                        Instagram
                    </InstapaperShareButton> */}
                </MenuItem>
            </Menu>
        </div>
    )
}

export default Share
